import { useEffect, useState } from "react";
import { getComplexDetailV3, searchEducationsV2, searchFrontYards, searchLivingAreas } from '../../../repository/RealEstateRepository';
import { ComplexDetail } from '../organism';
import { DefaultPage } from "./DefaultPage";

const ComplexDetailPage = (props) => {
  const [complexDetail, setComplexDetail] = useState(null);
  const [complexEvaluation, setComplexEvaluation] = useState(null);
  const [complexTransport, setComplexTransport] = useState(null);
  const [complexEducation, setComplexEducation] = useState(null);
  const [complexStats, setComplexStats] = useState(null);

  const [frontYards, setFrontYards] = useState([]);
  const [livingAreas, setLivingAreas] = useState([]);
  const [educationSet, setEducationSet] = useState(null);

  const getLinks = () => [
    {
      title: "Home",
      to: "/realestate"
    },
    {
      title: "Complex",
      to: "/realestate/complex"
    },
    {
      title: "Detail",
    }
  ];

  useEffect(() => {
    const { complexId } = props.match.params;
    // TODO
    searchFrontYards({}, (res) => setFrontYards(res.content));
    getComplexDetailV3({ id: complexId }, (res) => {
      setComplexDetail(res);
      setComplexStats(res.ageStats);
      setComplexTransport(res.transport);
      setComplexEducation(res.education);
      setComplexEvaluation(res.evaluation);
      // env
      searchLivingAreas({ frontYardId: res.livingArea.frontYard.id }, (res) => setLivingAreas(res.content));
      searchEducationsV2({ types: ["MIDDLE_SCHOOL", "ELEMENTARY_SCHOOL", "ACADEMY_STREET"].join(","), centerLat: res.latitude, centerLng: res.longitude }, (res) => setEducationSet(res));
    });
  }, [props.match.params]);

  return (<>
    <DefaultPage pathname={props.location.pathname} links={getLinks()}>
      {complexDetail != null && (<>
        <ComplexDetail
          goBack={props.history.goBack}
          complex={complexDetail}
          complexStats={complexStats}
          complexTransport={complexTransport}
          complexEducation={complexEducation}
          complexEvaluation={complexEvaluation}
          educations={educationSet}
          frontYards={frontYards}
          livingAreas={livingAreas} />
      </>)}
    </DefaultPage>
  </>);
};

export { ComplexDetailPage };
